// Others
import { urlApiEstimate, urlApiSchedule } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IDetailEstimate,
  IEstimate,
  IEstimateDetailUpdate,
  IFormEstimate,
  IParamGetListEstimate,
  IParamsDetailEstimate,
  IPayloadChangeStatusEstimate,
  IPayloadDetailUpdateEstimate,
  IPayloadSendEstimate,
  IQueryUpdateEstimate,
} from '~/utils/interface/estimate';
import { IParamSchedule, ISchedule, IScheduleTimeLine } from '~/utils/interface/schedule';
import axiosClient from './axiosClient';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const estimateApi = {
  createEstimate(payload: IFormEstimate) {
    const url = urlApiEstimate.createEstimate;
    return axiosClient.post<IBaseResponse>(url, payload);
  },

  getListEstimate(params: IParamGetListEstimate) {
    const url = urlApiEstimate.getListEstimate;
    return axiosClient.get<IBaseResponse<IListDataResponse<IEstimate[]>>>(url, { params });
  },

  getDetailEstimate(params: IParamsDetailEstimate) {
    const url = urlApiEstimate.getEstimateDetail(params.estimateId);
    return axiosClient.get<IBaseResponse<IDetailEstimate>>(url, {
      params: { type: params.type },
    });
  },

  updateEstimate: ({ estimateId, body }: IQueryUpdateEstimate) => {
    const url = urlApiEstimate.updateEstimate(estimateId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  getScheduleList(params: IParamSchedule) {
    const url = urlApiSchedule.getScheduleList;
    return axiosClient.get<IBaseResponse<ISchedule[] | IListDataResponse<IScheduleTimeLine[]>>>(url, {
      params,
    });
  },

  getEstimateDetailUpdate(payload: IPayloadDetailUpdateEstimate) {
    const { estimateId, params } = payload;
    const url = urlApiEstimate.getEstimateDetailUpdate(estimateId);
    return axiosClient.get<IBaseResponse<IEstimateDetailUpdate>>(url, {
      params,
    });
  },

  convertToJob: (estimateId: string) => {
    const url = urlApiEstimate.convertToJob(estimateId);
    return axiosClient.post<IBaseResponse>(url);
  },

  deleteEstimate(estimateId: string) {
    const url = urlApiEstimate.deleteEstimate(estimateId);
    return axiosClient.delete<IBaseResponse>(url);
  },

  sendEstimate(payload: IPayloadSendEstimate) {
    const { estimateId, body } = payload;
    const url = urlApiEstimate.sendEstimate(estimateId);
    return axiosClient.post<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  changeStatus(payload: IPayloadChangeStatusEstimate) {
    const { estimateId, body } = payload;
    const url = urlApiEstimate.changeStatus(estimateId);
    return axiosClient.put<IBaseResponse>(url, body);
  },
};

export default estimateApi;
